import React, { memo, useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import BMText from '../Text/BMText';
import { SlotItemTypeList } from './types';
import { BMPrimitives, useBMTheme } from '../../theme';
import useBottomComponentRenderer from './useDateCellAdditionalSlotRenderer';
function HolidayBadge(props) {
    const { activeTheme, BMComponents } = useBMTheme();
    const [styles, setStyles] = useState(legendBadgeStyles(BMComponents));
    const { definition, legendType } = props;
    const bottomComponentType = typeof legendType === 'string' && SlotItemTypeList.includes(legendType)
        ? legendType
        : undefined;
    let bottomComponent = useBottomComponentRenderer(bottomComponentType);
    useEffect(() => {
        setStyles(legendBadgeStyles(BMComponents));
    }, [activeTheme]);
    if (!bottomComponent) {
        bottomComponent = legendType;
    }
    // Return null if it is string and not one of the bottomComponentType to avoid `string string` format
    if (typeof legendType === 'string' && !SlotItemTypeList.includes(legendType)) {
        return null;
    }
    return (<View style={styles.container}>
      <View style={styles.legend}>{bottomComponent}</View>
      <BMText variant={'uiSmall'} ink={'BMStyleTextInkSecondary'}>
        {definition}
      </BMText>
    </View>);
}
const legendBadgeStyles = (BMComponents) => StyleSheet.create({
    container: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: BMComponents.BMUiCalendarBgcolorBadgeLegend,
        alignSelf: 'flex-start',
        padding: BMPrimitives.BMSize.sm,
        borderRadius: BMPrimitives.BMRadius.md,
    },
    legend: {
        marginRight: BMPrimitives.BMSize.xs,
    },
});
export default memo(HolidayBadge);
